/**
 * ToggleSwitch — iOS-style on/off toggle.
 */

import styles from './ToggleSwitch.module.css';

export type ToggleSwitchSize = 'sm' | 'md';

export interface ToggleSwitchProps {
  value: boolean;
  onChange: (value: boolean) => void;
  haptic?: { impact: (style: 'light' | 'medium' | 'heavy') => void };
  className?: string;
  size?: ToggleSwitchSize;
}

export const ToggleSwitch = ({
  value,
  onChange,
  haptic,
  className,
  size = 'md',
}: ToggleSwitchProps) => (
  <button
    type="button"
    className={`${styles.toggle} ${size === 'sm' ? styles.sm : ''} ${value ? styles.toggleActive : ''} ${className || ''}`}
    onClick={() => {
      haptic?.impact('light');
      onChange(!value);
    }}
  >
    <span className={styles.knob} />
  </button>
);
